import React, { useEffect, useRef } from "react";

let contatore = 0;

/** Finestra modale della tab Kit Moda: overlay, Esc per chiudere, header e footer fissi. */
function KitModaModal({ title, subtitle, onClose, footer, children, busy = false }) {
  // React 17 non ha useId: un id stabile per istanza basta per aria-labelledby.
  const titleId = useRef(`kitModaModalTitolo${(contatore += 1)}`).current;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !busy) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [busy, onClose]);

  return (
    <div
      className="fixed top-0 left-0 right-0 bottom-0 z-999 sfondoOverlayTema flex items-center justify-center pa3"
      onMouseDown={() => {
        if (!busy) onClose();
      }}
    >
      <div
        className="kitModaModal sfondoBiancoTema br3 shadow-5"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="kitModaModalHeader">
          <h3 id={titleId} className="ma0">
            {title}
          </h3>
          {subtitle && <p className="mt1 mb0 f6 scrittaColMedio">{subtitle}</p>}
        </div>
        <div className="kitModaModalBody">{children}</div>
        {footer && <div className="kitModaModalFooter">{footer}</div>}
      </div>
    </div>
  );
}

export default KitModaModal;
